module.exports = __webpack_public_path__ + "img/error2.f13377c9.png";